import React, { useState, useEffect, FC } from 'react';
import Loader from './Components/Loader';
import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Tracker from './Components/Tracker';

const App: FC = () => {
  const [loading, setLoading] = useState<boolean>(true);

  const queryClient = new QueryClient();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className='App'>
      <QueryClientProvider client={queryClient}>
        {loading ? (
          <Loader />
        ) : (
          <div>
            <Tracker />
          </div>
        )}
      </QueryClientProvider>
    </div>
  );
};

export default App;
